import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { OnboardingCtaComponent } from "@m19-board/containers/board-layout/board-sidebar/onboarding-cta.component";

@Component({
  selector: "app-onboarding-call-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, OnboardingCtaComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="promo"
      [title]="t('overlays.onboarding_call_title')"
      [subtitle]="t('overlays.onboarding_call_subtitle')"
    >
      <p overlayBody>{{ t("overlays.onboarding_call_description") }}</p>
      <app-onboarding-cta overlayCta />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingCallOverlayComponent {
  static readonly rule = OverlayRule.SCHEDULE_ONBOARDING_CALL;
}
